// Pricing — plan annual prices (USD)
export const BASEBALL_ANNUAL_PRICE = 49;
export const MULTI_SPORT_ANNUAL_PRICE = 99;

/** @deprecated Use BASEBALL_ANNUAL_PRICE or MULTI_SPORT_ANNUAL_PRICE */
export const ANNUAL_PRICE = BASEBALL_ANNUAL_PRICE;

// Early-bird discount for launch/promotions (reserved for future use)
export const EARLY_BIRD_PRICE = 36;
